module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_vm._v("\n            Ward: "), _c('strong', [_vm._v(_vm._s(_vm.selection.name) + "        ")]), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._l((_vm.wards), function(ward) {
    return [_c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.SelectWard(ward)
        }
      }
    }, [_c('strong', {
      staticClass: "text-primary"
    }, [_vm._v(_vm._s(ward.name))]), _c('br')])])]
  })], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-98ad8f14", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98ad8f14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/WardSelector/WardSelector.scp.html
// module id = 504
// module chunks = 0